'use strict';

var _ = require('lodash');
var SystemStatusInterfaceStatusTransformerFactory = function SystemStatusInterfaceStatusTransformerFactory(DataTransformer, momentService, App, featureToggleService, SystemStatusFileEventTitles) {
  function SystemStatusInterfaceStatusTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'system-status-interface-status-mode';
    this.priority = 1;
  }
  SystemStatusInterfaceStatusTransformer.prototype = Object.create(DataTransformer.prototype);
  SystemStatusInterfaceStatusTransformer.constructor = SystemStatusInterfaceStatusTransformer;
  SystemStatusInterfaceStatusTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  SystemStatusInterfaceStatusTransformer.prototype.isCacheable = function () {
    return false;
  };
  SystemStatusInterfaceStatusTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  SystemStatusInterfaceStatusTransformer.prototype.transform = function (data) {
    var response = _.get(data, 'domain', []);
    var fileTypesFeaturesMap = getFileTypesEnabledFeaturesMap();
    var enabledFileTypes = _.keys(fileTypesFeaturesMap);
    response = _.chain(response).filter(function (interfaceFile) {
      return _.includes(enabledFileTypes, interfaceFile.fileType);
    }).map(function (interfaceFile) {
      return transformInterfaceFileRecord(interfaceFile, fileTypesFeaturesMap);
    }).value();
    return response;
  };
  function getFileTypesEnabledFeaturesMap() {
    return _.chain(App.systemStatusConfigMap).pickBy(function (value, app) {
      return featureToggleService.isEnabled(app);
    }).transform(function (result, fileTypes, app) {
      _.forEach(fileTypes, function (fileType) {
        result[fileType] = result[fileType] || [];
        result[fileType].push(app);
      });
    }).value();
  }
  function transformInterfaceFileRecord(interfaceFile, fileTypesFeaturesMap) {
    var memoizedMomentOfStartDate = _.memoize(getMomentOfDate);
    var memoizedMomentOfCompletionDate = _.memoize(getMomentOfDate);
    interfaceFile.apps = fileTypesFeaturesMap[interfaceFile.fileType];
    interfaceFile.event = interfaceFile.fileType;
    interfaceFile.fileType = prepareFileEventTitle(interfaceFile);
    interfaceFile.frequency = fileEventFrequency(interfaceFile.event);
    interfaceFile.startDate = memoizedMomentOfStartDate(interfaceFile.startDate, momentService.FIELD.LAST_UPDATED_AT);
    interfaceFile.completionDate = memoizedMomentOfCompletionDate(interfaceFile.completionDate, momentService.FIELD.LAST_UPDATED_AT);
    interfaceFile.processedCount = setProcessedCount(interfaceFile);
    return interfaceFile;
  }
  function isYieldsDPAdjustmentFile(interfaceFile) {
    return 'YIELDS' === interfaceFile.event && !_.isNil(interfaceFile.recordCount) && _.isNil(interfaceFile.recordCount.processedCount) && !_.isNil(interfaceFile.recordCount.secondaryProcessedCount);
  }
  function prepareFileEventTitle(interfaceFile) {
    var title = 'n/a';
    if (isYieldsDPAdjustmentFile(interfaceFile)) {
      title = fileEventTitle('DP_ADJUSTMENT');
    } else {
      title = fileEventTitle(interfaceFile.event);
    }
    return title;
  }
  function setProcessedCount(interfaceFile) {
    var queuesWithSplitStatisticsDisplay = ['FO_FM_OUTBOUND_REQUEST'];
    if (!_.isNil(interfaceFile.recordCount) && !_.isNil(interfaceFile.recordCount.processedCount)) {
      if (interfaceFile.direction === 'Input') {
        return interfaceFile.recordCount.inputCount + '/' + interfaceFile.recordCount.processedCount;
      }
      if (interfaceFile.direction === 'Output' && _.includes(queuesWithSplitStatisticsDisplay, interfaceFile.event)) {
        return interfaceFile.recordCount.inputCount + '/' + interfaceFile.recordCount.processedCount;
      }
      if (interfaceFile.fileStatus !== 'Error') {
        return interfaceFile.recordCount.processedCount;
      }
    }
    if (isYieldsDPAdjustmentFile(interfaceFile)) {
      return interfaceFile.recordCount.secondaryProcessedCount;
    }
    return 'n/a';
  }
  function fileEventTitle(fileEvent) {
    return _.get(SystemStatusFileEventTitles, [fileEvent], '');
  }
  function fileEventFrequency(fileEvent) {
    var mapToHepConfig = {
      SHOPPING: 'Shopping',
      INFARE: 'CompFare',
      AVERAGEFARE: 'AverageFare',
      UNIQUEPRESENCE: 'UniquePresence',
      SCHEDULE: 'Schedule',
      ACTIVERECOMMENDATIONS: 'ActiveRecommendations',
      C2CLOADEDUPSELL: 'C2CLoadedUpsell',
      P2PLOADEDUPSELL: 'P2PLoadedUpsell',
      YIELDS: 'Yields',
      FOWEBFARE: 'FOWebFare',
      FOFM_CURRENCY_EXCHANGE_RATES: 'FOFMCurrencyExchangeRates',
      FO_FM_OUTBOUND_REQUEST: 'FaresOptimizerFMOutboundRequest',
      FO_RESOLVED_FARE_TRIGGER: 'FaresOptimizerResolvedFareTrigger',
      BUY_DOWN: 'BuyDownReport',
      INVENTORY: 'Inventory',
      OD_AVAILABILITY: 'Availability',
      PRICE_RECOMMENDATION_BOOKING_CURVE: 'BookingCurve',
      PRICE_RECOMMENDATION_SEASON_ASSIGNMENT: 'SeasonAssignment',
      PRICE_RECOMMENDATION_FORECASTED_LF: 'ForecastedLF',
      DP_ADJUSTMENT: 'DPAdjustment',
      PRICE_RECOMMENDATION_PNR: 'PNR',
      VM_REPORT: 'VMReport',
      SHOP_REPORT: 'ShopReport',
      EXCLUDED_RECOMMENDATIONS: 'ExcludedRecommendations'
    };
    return _.get(App.interfaceStatusFrequency, mapToHepConfig[fileEvent], '');
  }
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return SystemStatusInterfaceStatusTransformer;
};
SystemStatusInterfaceStatusTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'App', 'FeatureToggleService', 'SystemStatusFileEventTitles'];
module.exports = SystemStatusInterfaceStatusTransformerFactory;